<template>
  <div>
    <el-tabs v-model="activePane" @tab-click="onTabChange">
      <el-tab-pane name="P">
        <span slot="label">Pending</span>
      </el-tab-pane>
      <el-tab-pane name="D">
        <span slot="label">Fulfilled</span>
      </el-tab-pane>
    </el-tabs>
    <div class="card shadow">
      <div class="card-header">
        Requests
      </div>
      <div v-loading="loading">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th>Requested Recipe</th>
              <th v-if="$store.getters.isAdmin">Operations</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="request in requests" :key="request.id">
              <td>
                <span v-if="request.users.length >= 100" class="badge badge-pill badge-danger mr-2">{{ request.users.length }}</span>
                <span v-else class="badge badge-pill badge-secondary mr-2">{{ request.users.length }}</span>
                <el-tooltip v-if="request.status === 'A'" content="In Progress" placement="bottom">
                  <i class="fas fa-circle" style="color: #E6A23C;"></i>
                </el-tooltip>
                {{ request.desc }}
              </td>
              <td v-if="$store.getters.isAdmin">
                <div v-if="request.status !== 'D'">
                  <request-manage :request="request" @update="getRequests" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import RequestManage from '@/components/Request/RequestManage'

export default {
  data() {
    return {
      loading: true,
      activePane: 'P',
      requests: [],
    }
  },
  components: {
    RequestManage,
  },
  mounted() {
    this.getRequests()
  },
  methods: {
    onTabChange(tab, event) {
      this.activePane = tab.name
      this.getRequests()
    },
    async getRequests() {
      this.loading = true
      try {
        var { data } = await this.$http.get(`/requests`, {
          params: {
            status: this.activePane,
            limit: 512,
          },
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }
      this.requests = data
    },
  },
}
</script>

<style scoped>
.request-item:not(:last-child) {
  border-bottom: 1px solid #e6ebf5;
}
</style>
